/**
 * One or many, in words.
 *
 * The panel counted things and then hedged about them: "3 conversación(es)
 * esperan respuesta", "1 candidatura(s) sin responder", "1 mensaje(s)". That
 * is the voice of a form at a ministry, and it is written by a program that
 * knows the number and declines to use it. We always know the number.
 *
 * Both phrases are passed in full rather than assembled from a stem, because
 * Spanish agreement reaches past the noun: one conversation *espera*, three
 * *esperan*, and a rule that only pluralises the noun gets the verb wrong.
 *
 *   `${n} ${plural(n, "conversación espera respuesta", "conversaciones esperan respuesta")}`
 */
export function plural(count: number | null | undefined, one: string, many: string): string {
    return count === 1 ? one : many;
}
